// @flow

import invariant from 'invariant';

import _ from 'lodash';

import Q from 'q';
import type { QPromise } from 'types/q';

import ko from 'rgs-knockout';
import type {
	Computed,
} from 'rgs-knockout';

import ObservableSet from 'observable-set';


export interface ObservableBusyInterface {
	constructor(): void;

	add<T> (arg: Promise<T>): QPromise<T>;
	add<T> (arg: QPromise<T>): QPromise<T>;
	add (arg: ObservableBusyInterface): ObservableBusyInterface;

	delete (any): void;

	isBusy (): boolean;

	dispose (): void;
}


class ObservableBusyClass implements ObservableBusyInterface {
	_businesses: ObservableSet;
	isBusy: Computed<boolean>;

	constructor () {
		this._businesses = new ObservableSet;

		this.isBusy = ko.pureComputed(this.isBusy.bind(this));
	}

	add (arg: any) {
		if (Q.isPromiseAlike(arg)) {
			Q(arg).finally(() => {
				this._businesses.delete(arg);
			});
		} else if (arg instanceof ObservableBusy) {
			// noop
		} else {
			throw new TypeError('Only works with Promise and ObservableBusy');
		}

		this._businesses.add(arg);

		if (Q.isPromiseAlike(arg)) {
			return Q(arg);
		}

		return arg;
	}

	delete (arg: any): void {
		this._businesses.delete(arg);
	}

	isBusy (): boolean {
		return _.some(this._businesses.values(), (v) => this._isBusy(v));
	}

	_isBusy<T, U: Promise<T> | ObservableBusy> (arg: U): boolean {
		if (Q.isPromiseAlike(arg)) {
			return this._isBusyPromise((arg: any));
		}

		invariant(
			arg instanceof ObservableBusy,
			'Only `Promise` or `ObservableBusy` can be added'
		);
		return this._isBusyObservableBusy(arg);
	}

	_isBusyPromise<T> (promise: Promise<T>) {
		return Q(promise).inspect().state !== 'fulfilled';
	}

	_isBusyObservableBusy (ob: ObservableBusy) {
		return ob.isBusy();
	}

	dispose () {
		this.isBusy.dispose();
	}
}

export const ObservableBusy: Class<ObservableBusyInterface> = (ObservableBusyClass: any);
